import PostNote from "../../../../src/styled/PostNote";
import React from 'react';
export default {
  PostNote,
  React
};